import React from "react";
import {
    List,
    ListItem,
    ListItemText,
    Menu,
    MenuItem,
    MenuProps,
    alpha,
    styled,
} from "@mui/material";

const options = [
    "Year",
    "2023",
    "2022",
    "2021",
    "2020",
    "2019",
    "2018",
    "2017",
];

const StyledMenu = styled((props) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
        }}
        transformOrigin={{
            vertical: "top",
            horizontal: "center",
        }}
        {...props}
    />
))(({ theme }) => ({
    "& .MuiPaper-root": {
        borderRadius: 8,
        marginTop: "5px",
        minWidth: "61px",
        color:
            theme.palette.mode === "light"
                ? "rgb(55, 65, 81)"
                : theme.palette.grey[300],
        boxShadow: "0px 0px 4px 1px rgba(0, 0, 0, 0.08)",
        "& .MuiMenu-list": {
            padding: "11px 5px !important",
        },
        "& .MuiMenuItem-root": {
            fontWeight: "500",
            fontSize: "12px",
            color: "#7D7D7D",
            padding: "1px 3px",
            borderRadius: "5px",
            marginBottom: "3px",
            "&.Mui-selected": {
                background: "#F3F3F3",
            },
            "&:first-child": {
                display: "none",
            },
            "&:hover": {
                color: "#4b4b4b",
                background: "#F3F3F3",
            },
            "&:active": {
                background: "#F3F3F3",
                borderRadius: "5px",
            },
        },
    },
}));

const SelectYear = (props) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClickListItem = (event) => {
        setAnchorEl(event.currentTarget);
    };
    // console.warn(anchorEl)
    const handleMenuItemClick = (event, index) => {
        setAnchorEl(null);
        props.sendDataToParent({ year: options[index] });
        props.setYear(index);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    return (
        <>
            <List
                component="div"
                aria-label="Device settings"
                className="year_divlst"
            >
                <ListItem
                    key="lock-button"
                    id="lock-button"
                    aria-haspopup="listbox"
                    aria-controls="lock-menu"
                    aria-expanded={open ? "true" : undefined}
                    onClick={handleClickListItem}
                    className={
                        props?.value !== 0
                            ? "onFocus byYear "
                            : "selectCommon byYear"
                    }
                >
                    <ListItemText secondary={options[props?.value]} />
                </ListItem>
            </List>
            <StyledMenu
                id="lock-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    "aria-labelledby": "lock-button",
                    role: "listbox",
                }}
            >
                {options.map((option, index) => (
                    <MenuItem
                        key={option}
                        disabled={index === 0}
                        selected={index === props?.value}
                        onClick={(event) => handleMenuItemClick(event, index)}
                    >
                        {option}
                    </MenuItem>
                ))}
            </StyledMenu>
        </>
    );
};

export default SelectYear;
